export abstract class UserAuthProvider {
  private config;
  public supportsPkce: boolean;

  constructor(config: {}) {
    this.config = config;
  }

  public getUser() {
    return Promise.resolve(undefined);
  }

  public async isAuthenticated(): Promise<boolean> {
    return false;
  }

  public async redirect(params: any): Promise<any> {
    return false;
  }

  public isInLoginRedirect(): boolean {
    return false;
  }

  public async storeAuthTokensFromCallback(): Promise<any> {
    return false;
  }

  public signIn(params: { password: string; username: string }) {
    return Promise.resolve(undefined);
  }

  public signInWithToken(token: string) {
    return Promise.resolve(undefined);
  }

  public async getAccessToken() {
    return '';
  }

  public async getIdToken() {
    return '';
  }

  public logout(path: string) {
    return Promise.resolve(undefined);
  }
}
